import AssignedColumn from './AssignedColumn';
import type { AssignedColumnProps } from './types';

export default AssignedColumn;
export type { AssignedColumnProps };
